import { ReactElement, use, useEffect, useMemo } from 'react';
import { HymnalWithHymns } from '../data/hymnals.ts';
import { FavoritesContext } from '../data/use_favorites.tsx';
import { FavoritesHymnalId } from '../data/use_hymnals.tsx';
import '../util/shared.css';
import { HymnsList } from '../views/hymns_list.tsx';

export const favoritesHymnalIconPath = '/images/bookmark.png';

const favoritesHymnalAttributes: Omit<HymnalWithHymns, 'hymns'> = {
  id: FavoritesHymnalId,
  name: 'Favorites',
  slug: 'FAVORITES',
  icon: { path: favoritesHymnalIconPath },
  hideTitle: true,
};

export const FavoritesPage = () => {
  const { favoriteHymns, setEnableServerSync } = use(FavoritesContext);

  const message = useMemo<ReactElement | undefined>(() => {
    if (favoriteHymns.length === 0) {
      return <div>Open a song to mark it as a favorite</div>;
    } else {
      return undefined;
    }
  }, [favoriteHymns.length]);

  const favoritesHymnal = useMemo<HymnalWithHymns>(
    () => ({ ...favoritesHymnalAttributes, hymns: favoriteHymns, message }),
    [favoriteHymns, message],
  );

  useEffect(() => {
    setEnableServerSync(true);
    return () => setEnableServerSync(false);
  }, [setEnableServerSync]);

  return <HymnsList hymnals={[favoritesHymnal]} title="Favorites" showProfileAvatar />;
};
